import { h, Component } from "preact";

import Collapsible from "./Collapsible";
import Loading from "./Loading";
import CopyToClipboard from "./CopyToClipboard";

class ProjectPane extends Component {
  constructor(props) {
    super(props);
    this.state = {};

    this.loadEnvironment = this.loadEnvironment.bind(this);
    this.toggleSshRoutes = this.toggleSshRoutes.bind(this);
    this.toggleHttpRoutes = this.toggleHttpRoutes.bind(this);
    this.togglePsssh = this.togglePsssh.bind(this);
  }

  loadEnvironment() {
    const { project } = this.props.projectContext;
    if (!project || this.state.environment || this.state.environmentLoading) {
      return false;
    }

    this.setState({
      environmentLoading: true
    });

    this.props.client
      .getEnvironment(project.project_id, "master")
      .then(environment => {
        const sshUrls = environment.getSshUrls();

        this.setState({
          environmentLoading: false,
          environment,
          routesLinks: environment.getRouteUrls(),
          sshLinks: Object.keys(sshUrls).map(key =>
            sshUrls[key].replace("ssh://", "ssh ")
          )
        });
      });
  }

  toggleSshRoutes() {
    this.loadEnvironment();

    this.setState(prevState => ({
      sshRoutes: !prevState.sshRoutes,
      httpRoutes: false,
      psssh: false
    }));
  }

  toggleHttpRoutes() {
    this.loadEnvironment();

    this.setState(prevState => ({
      sshRoutes: false,
      httpRoutes: !prevState.httpRoutes,
      psssh: false
    }));
  }

  togglePsssh() {
    this.loadEnvironment();

    this.setState(prevState => ({
      sshRoutes: false,
      httpRoutes: false,
      psssh: !prevState.psssh,
    }));
  }

  render(
    { projectContext = {}, username = "", defaultOpen },
    { routesLinks = [], sshLinks = [], environmentLoading, sshRoutes, httpRoutes, psssh }
  ) {
    const { project, links } = projectContext;

    if (!project || Object.keys(project).length === 0) {
      return false;
    }
    const clusterRoot = `root.clusters["${project.project_id}"]`;
    const hostname = `ssh ${username}@psssh.eu.platform.sh`;
    const projectTitle = (!project.project_title || !project.project_title.length) ? "[ Untitled Project ]" : project.project_title;

    return (
      <Collapsible title="Current Project" defaultOpen={defaultOpen}>
        <div class="user-widget__mega_menu__admin--info">
          <div class="name">{projectTitle}</div>
          <div class="id">{project.project_id}</div>
          <div class="size">{project.plan}</div>
        </div>
        <ul class="user-widget__mega_menu__admin--links">
          {links.map(link => (
            <li>
              <a
                href={link.url}
                target="_blank"
                rel="noopener noreferrer"
              >
                {link.label}
              </a>
            </li>
          ))}
        </ul>
        <div class="user-widget__mega_menu__admin--tips">
          <Collapsible title="SSH Routes" onClick={this.toggleSshRoutes} open={sshRoutes}>
            {environmentLoading && <Loading />}
            {sshLinks.map(link => (
              <div>
                <input
                  type="text"
                  class="user-widget__collapsible__content__item"
                  value={link}
                />
                <CopyToClipboard text={link} />
              </div>
            ))}
          </Collapsible>
          <Collapsible title="HTTP Routes" onClick={this.toggleHttpRoutes} open={httpRoutes}>
            {environmentLoading && <Loading />}
            {routesLinks.map(route => (
              <div>
                <input
                  type="text"
                  class="user-widget__collapsible__content__item"
                  value={route}
                />
                <CopyToClipboard text={route} />
              </div>
            ))}
          </Collapsible>
          <Collapsible title="PSSSH" onClick={this.togglePsssh} open={psssh}>
            <div>
              <input
                type="text"
                class="user-widget__collapsible__content__item"
                value={hostname}
              />
              <CopyToClipboard text={hostname} />
            </div>
            <div>
              <input
                type="text"
                class="user-widget__collapsible__content__item"
                value={clusterRoot}
              />
              <CopyToClipboard text={clusterRoot} />
            </div>
          </Collapsible>
        </div>
      </Collapsible>
    );
  }
}

export default ProjectPane;



// WEBPACK FOOTER //
// ./src/ProjectPane.js